<section class="entity">
    <header class="entityHeader">
        <div class="actions">
            @if (infoDirty()) {
                <lib-helper-info message="Unsaved changes"></lib-helper-info>
                <button class="secondary-btn" type="button" (click)="onCancelCustomInfo()">Cancel</button>
                <button class="primary-btn" type="button" (click)="onSaveCustomInfo()">Save</button>
            }
        </div>
        <div class="entityHeaderTitle">
            <span class="entityTitle">{{ entityName() }}</span>
            <div class="entityHeaderActions">
                @if (canAddNewInfo()) {
                    <button class="secondary-btn" type="button" (click)="addCustomInfo()">
                        <span class="icon" [innerHTML]="plusIcon"></span> New field
                    </button>
                }
            </div>
        </div>
    </header>
    <app-customization-filters
        [entityTypeId]="entityTypeId()"
        (filtersChange)="onFiltersChange($event)"
    ></app-customization-filters>

    <div class="entityGrid">
        @if (hasNoCustomInfo()) {
            <div class="noData">
                <lib-no-data
                    [iconName]="'empty'"
                    [title]="'You don\'t have any item.'"
                    [text]="'Please add a new one to use on the workflow.'"
                ></lib-no-data>
            </div>
        } @else {
            <article class="entityCard">
                <form [formGroup]="customInfoForm">
                    <div
                        class="entityList"
                        formArrayName="infoItems"
                        cdkDropList
                        cdkDropListOrientation="vertical"
                        (cdkDropListDropped)="onInfoDrop($event)"
                    >
                        @for (
                            info of customInfoArray.controls;
                            track info.controls.id.value ?? $index;
                            let i = $index
                        ) {
                            @let isActive = info.controls.isActive.value;
                            @let isReserved = info.controls.isReserved.value;

                            <div class="entityRow" [formGroupName]="i" cdkDrag>
                                <div class="wrapper" [class.locked]="isReserved">
                                    <div class="container">
                                        <div class="dragButton" cdkDragHandle aria-label="Reorder info">
                                            <button class="resetStyles dragIndicator" type="button">
                                                <span class="icon" [innerHTML]="dragIndicatorIcon"></span>
                                            </button>
                                        </div>

                                        <div class="body">
                                            <div class="fieldRow">
                                                <app-reactive-field-input
                                                    [label]="'Description'"
                                                    [control]="info.controls.name"
                                                    [readonly]="!!isReserved"
                                                    [placeholder]="'Add Description'"
                                                    [maxLength]="200"
                                                    [shouldTrimSpaces]="true"
                                                ></app-reactive-field-input>
                                            </div>
                                        </div>

                                        <div class="actions" [class.iconLocked]="isReserved">
                                            @if (isReserved) {
                                                <div class="lockedIcon">
                                                    <span class="icon" [innerHTML]="lockedIcon"></span>
                                                </div>
                                            } @else if (!infoDirty()) {
                                                @if (isActive) {
                                                    <button
                                                        type="button"
                                                        class="resetStyles tooltipButton"
                                                        (click)="onToggleCondition(i, true)"
                                                        title="Archive"
                                                    >
                                                        <span class="icon" [innerHTML]="archiveIcon"></span>
                                                    </button>
                                                } @else {
                                                    <button
                                                        type="button"
                                                        class="resetStyles tooltipButton"
                                                        (click)="onToggleCondition(i, false)"
                                                        title="Restore"
                                                    >
                                                        <span class="icon" [innerHTML]="restoreIcon"></span>
                                                    </button>
                                                }
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </form>
            </article>
        }
    </div>
</section>
